import { createGlobalStyle } from 'styled-components';

const CoreStyles = createGlobalStyle`
  :root {
    --doc-height: 100vh;
  }
  
  .ekyc-page {
    font-family: "Roboto", sans-serif;
    height: 100vh;
    height: var(--doc-height);
    background-color: #f6f6f6;
    max-width: 1140px;
    margin: auto;
  }
  
  .ekyc-page .header {
    position: relative;
    background: #ffffff;
    z-index: 1000;
    display: none;
  }
  
  .ekyc-page .header > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 0px;
    height: 60px;
  }
  .ekyc-page .header img {
    height: 100%;
    width: auto;
  }
  
  .ekyc-page input::-webkit-input-placeholder,
  .ekyc-page input::placeholder {
    color: #a2a8b4;
  }
  .ekyc-page .btn,
  .ekyc-page .btn-primary {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 40px;
    background: linear-gradient(93.08deg, #c5281c 10.94%, #e4513c 96.25%);
    border-radius: 16px;
    border: none;
    outline: none;
    color: #ffffff;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }
  
  .ekyc-page .btn-secondary {
    border: 1.5px solid #eef0f3;
    color: #5e6671;
    background: transparent;
    border-radius: 16px;
  }
  
  .ekyc-page .btn:focus,
  .ekyc-page .btn-primary:focus,
  .ekyc-page .btn-primary:not(:disabled):not(.disabled).active:focus,
  .ekyc-page .btn-primary:not(:disabled):not(.disabled):active:focus,
  .ekyc-page .show > .btn-primary.dropdown-toggle:focus {
    box-shadow: none;
    outline: none;
    border: none;
  }
  
  .ekyc-page .btn-secondary:focus,
  .ekyc-page .btn-secondary:not(:disabled):not(.disabled).active:focus,
  .ekyc-page .btn-secondary:not(:disabled):not(.disabled):active:focus {
    border: 1.5px solid #eef0f3;
    box-shadow: none;
  }
  
  .ekyc-page .form-field {
    display: flex;
    margin-bottom: 12px;
    border: 1px solid #eef0f3;
    background: #ffffff;
    padding: 6px 16px;
    border-radius: 16px;
    justify-content: center;
    align-items: center;
    min-height: 63px;
  }
  .ekyc-page .form-field .genic {
    font-size: 10px;
    color: #a0a0a0;
  }
  .ekyc-page .form-field .genic-edit {
    font-size: 20px;
    cursor: pointer;
  }
  
  .ekyc-page .form-field.active .genic {
    color: #c5281c;
  }
  
  .ekyc-page .form-field .form-field-group {
    display: flex;
    flex-direction: column;
    flex: 1;
  }
  
  .ekyc-page .form-field .form-field-group .gselectpicker-wp,
  .ekyc-page .form-field .form-field-group .gform-field-group-wp {
    display: flex;
    width: 100%;
    position: relative;
  }
  
  .ekyc-page .form-field .form-field-group .gform-field-group-wp input {
    width: 100%;
  }
  .ekyc-page .form-field .form-field-group .gform-field-group-wp p {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #3d4148;
    margin: 0;
  }
  .ekyc-page .form-field .form-field-group .gform-field-group-wp .genic {
    position: absolute;
    right: 0;
    margin-top: -12px;
  }
  .ekyc-page .form-field .form-field-group .gselectpicker-wp .gdate {
    flex: 1;
  }
  .ekyc-page .form-field .form-field-group .gselectpicker-wp .genic-down {
    height: 10px;
    cursor: pointer;
  }
  
  .ekyc-page
    .form-field
    .form-field-group
    .gselectpicker-wp
    .dropdown.bootstrap-select.show
    ~ .genic.genic-down {
    transform: rotate(180deg);
    margin-top: -4px;
    color: #c5281c;
  }
  
  .ekyc-page .form-field label {
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    letter-spacing: 0.02em;
    color: #a2a8b4;
    margin-bottom: 2px;
  }
  
  .ekyc-page .form-field input {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #3d4148;
    padding: 0px;
  }
  
  .ekyc-page .form-field input,
  .ekyc-page .form-field input:focus {
    border: none;
    background: transparent;
    outline: none;
    box-shadow: none;
  }
  .ekyc-page .form-field input:focus + .genic {
    color: #c5281c;
  }
  
  .ekyc-page .form-field .dropdown-toggle,
  .ekyc-page .form-field .dropdown-toggle:focus,
  .ekyc-page .form-field .dropdown-toggle:active,
  .ekyc-page .form-field .dropdown-toggle:active:focus {
    color: #3d4148;
    background: transparent;
    border: none;
    outline: none !important;
    box-shadow: none;
  }
  
  .ekyc-page .form-field .dropdown-toggle::before,
  .ekyc-page .form-field .dropdown-toggle::after {
    content: unset;
  }
  
  .ekyc-page .form-field .dropdown-toggle .filter-option {
    padding: 0;
  }
  
  .ekyc-page .bootstrap-select .dropdown-menu .dropdown-item.active {
    background-color: #c5281c;
  }
  .ekyc-page .gselectpicker-wp .gdate {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }
  .ekyc-page .gselectpicker-wp .gdate input {
    width: 100%;
  }
  .ekyc-page .gselectpicker-wp .gdate .genic-calendar {
    font-size: 16px;
    right: 0;
    margin-top: -14px;
    position: absolute;
    cursor: pointer;
  }
  
  @media screen and (min-width: 769px) {
    .ekyc-page .header {
      display: block;
    }
  }

  /** Customize styles | GVL01767 2023-04-27 */
  .pointer {
    cursor: pointer
  }

  .title {
    font-size: 32px;
    color: rgb(197, 40, 28);
    text-align: center;
  }
  
  .permission-popup-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 24px;

    .title-success {
      color: rgb(111, 112, 114)
    }

    img {
      overflow: hidden;
      border-radius: 100%;
      width: 128px;
      height: 128px;
      margin-bottom: 24px;
    }

    p {
      font-style: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: #20252b;
      margin-bottom: 24px;
    }

    .btn-primary {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 12px 40px;
      background: linear-gradient(93.08deg, #c5281c 10.94%, #e4513c 96.25%);
      border-radius: 16px;
      border: none;
      outline: none;
      color: #ffffff;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
    }
  }
  
  .permission-popup-container .btn-primary:focus,
  .permission-popup-container .btn-primary:not(:disabled):not(.disabled).active:focus,
  .permission-popup-container .btn-primary:not(:disabled):not(.disabled):active:focus,
  .permission-popup-container .show > .btn-primary.dropdown-toggle:focus {
    box-shadow: none;
    outline: none;
    border: none;
  }
  
  @media screen and (max-width: 576px) {
    .permission-popup-container {
      padding: 0
    }

    .permission-popup-container.box-content {
      margin-top: 74px;
    }
  }

  .ant-modal-root button:not(.close-btn) {
    width: 100%;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    -webkit-text-decoration: none;
    text-decoration: none;
    padding: 12px 20px;
    max-width: 120px;
    margin: 0 auto;
  }

  .ant-modal-root .btn-primary {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 40px;
    background: linear-gradient(93.08deg, #c5281c 10.94%, #e4513c 96.25%);
    border-radius: 16px;
    border: none;
    outline: none;
    color: #ffffff;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }

  .ant-modal-root .btn:focus,
  .ant-modal-root .btn-primary:focus,
  .ant-modal-root .btn-primary:not(:disabled):not(.disabled).active:focus,
  .ant-modal-root .btn-primary:not(:disabled):not(.disabled):active:focus,
  .ant-modal-root .show > .btn-primary.dropdown-toggle:focus {
    box-shadow: none;
    outline: none;
    border: none;
  }

`;

export default CoreStyles;
